import G6 from '@antv/g6-pc';
G6.version = '4.5.3';
export * from '@antv/g6-pc';
export default G6;
export var version = '4.5.3';